<template>
  <div>
    <v-container>
      <field-label label="Pele" titleClass="text-h6" titleColorClass="grey--text text--darken-2">
        <v-row dense class="mt-1">
          <v-col>
            <field-label label="PASI" class="fill-height d-flex flex-column">
              <span
                class="big-number mt-auto"
                :class="{
                  'big-number--negative': computedPasi > 9,
                  'grey--text text-lighten-1': computedPasi === '?',
                }"
                >{{ computedPasi }}</span
              >
            </field-label>
          </v-col>
          <v-col>
            <field-label label="BSA" class="fill-height d-flex flex-column">
              <span
                class="big-number mt-auto"
                :class="{
                  'big-number--negative': computedBsa > 9,
                  'grey--text text-lighten-1': computedBsa === '?',
                }"
                >{{ computedBsa }}</span
              >
            </field-label>
          </v-col>
        </v-row>
      </field-label>
      <field-label label="Qualidade de vida" titleClass="text-h6" titleColorClass="grey--text text--darken-2">
        <v-row dense class="mt-1">
          <v-col>
            <field-label label="DLQI" class="fill-height d-flex flex-column">
              <span
                class="big-number mt-auto"
                :class="{
                  'big-number--negative': computedDlqi > 9,
                  'grey--text text-lighten-1': computedDlqi === '?',
                }"
                >{{ computedDlqi }}</span
              >
            </field-label>
          </v-col>
        </v-row>
      </field-label>
      <field-label label="Articulação" titleClass="text-h6" titleColorClass="grey--text text--darken-2">
        <v-row dense class="mt-1" v-if="haveArtrite === '?'">
          <v-col>
            <field-label label="PEST" class="fill-height d-flex flex-column">
              <span
                class="big-number mt-auto"
                :class="{
                  'big-number--negative': computedPest > 2,
                  'grey--text text-lighten-1': computedPest === '?',
                  'extra-info': computedPest >= 3,
                }"
                >{{ computedPest }}</span
              >
            </field-label>
          </v-col>
          <v-col>
            <field-label label="CASPAR" class="fill-height d-flex flex-column" v-if="!attendance.data.summarizedFlow">
              <span
                class="big-number mt-auto"
                :class="{
                  'big-number--negative': computedCaspar > 2,
                  'grey--text text-lighten-1': computedCaspar === '?',
                  'extra-info': computedCaspar >= 3,
                }"
                >{{ computedCaspar }}</span
              >
            </field-label>
          </v-col>
        </v-row>
        <v-row dense class="mt-1" v-else>
          <v-col>
            <field-label label="ARTRITE PSORIÁSICA" class="fill-height d-flex flex-column">
              <span
                class="big-number mt-auto"
                :class="{
                  'big-number--negative': haveArtrite === 'Sim',
                }"
                >{{ haveArtrite }}</span
              >
            </field-label>
          </v-col>
        </v-row>
        <v-row dense class="mt-1" v-if="computedPest >= 3 || computedCaspar >= 3">
          <v-col>
            <field-label label="*Artrite Suspeita" />
          </v-col>
        </v-row>
      </field-label>
    </v-container>
  </div>
</template>

<script>
import BaseSummary from '../../general/summary/BaseSummary.vue'
import FieldLabel from '@/components/FieldLabel.vue'
import psoriasisSummaryMixin from '@/components/AttendanceForm/psoriasis/mixins/psoriasisSummaryMixin.js'

import { createNamespacedHelpers } from 'vuex'
const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

export default {
  mixins: [psoriasisSummaryMixin],
  extends: BaseSummary,
  components: { FieldLabel },

  computed: {
    ...attendanceGettersMap(['attendance']),
  },
  methods: {
    getSummaryData() {
      return {
        pasi: { value: this.computedPasi ?? '', text: 'PASI' },
        bsa: { value: this.computedBsa ?? '', text: 'BSA' },
        dlqi: { value: this.computedDlqi ?? '', text: 'DLQI' },
        caspar: { value: this.computedCaspar ?? '', text: 'CASPAR' },
        pest: { value: this.computedPest ?? '', text: 'PEST' },
        haveArtrite: { value: this.haveArtrite ?? '', text: 'ARTRITE' },
      }
    },
  },
}
</script>

<style scoped>
.big-number {
  color: green;
  font-size: 1.5rem;
}
.big-number--negative {
  color: red;
}
.extra-info::after {
  content: '*';
  font-size: 16px;
  color: black;
  vertical-align: text-top;
}
</style>
